import {
  actionTypes,
} from '../actions';

import type {
  Action,
  ProfileState,
} from '../types';

const defaultMasterPro = {
  active_subscriptions_count: 0,
  new_subscriptions_count: 0,
  last_month_active_subscriptions_count: 0,
  total_users: 0,
  freemium_users: 0,
  users_in_trial: 0,
}
const initialState: ProfileState = {
  isAuth: null,
  isLoading: true,
  master_pro: defaultMasterPro,
}

const mergeValues = (
  values,
  state,
) => (
  Object.keys(values).reduce((s, v) => ({
    ...s,
    [v]: values[v]?._merge ? ({ /* eslint-disable-line */
      ...state[v],
      ...values[v],
    }) : (
      values[v]
    ),
  }), {})
);

const profile = (
  state: ProfileState = initialState,
  action: Action,
) => {
  switch (action.type) {
    case actionTypes.SET_PROFILE_STATE: {
      const {
        keyOrRootValues,
        maybeValues,
      } = action.payload;
      const [
        values,
        key,
      ] = (
          maybeValues === undefined
            ? [
              keyOrRootValues,
              null,
            ]
            : [
              maybeValues,
              keyOrRootValues,
            ]
        );
      return {
        ...state,
        ...(
          key
            ? ({
              [key]: {
                ...state[key],
                ...mergeValues(
                  values,
                  state[key],
                ),
              },
            })
            : (
              mergeValues(
                values,
                state,
              )
            )
        ),
      };
    }
    default:
      return state;
  }
};

export default profile;
